// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Dov5","paramInput":"JobSimulator_paramInput__3vuId","input":"JobSimulator_input__3nO2J"};